<template>
  <div>
    <div style="margin-bottom: 1rem">
      <el-button size="mini" @click="handleAdd" type="primary">添加用户</el-button>
    </div>

    <el-table
        :data="tableData"
        stripe
        style="width: 100%">
      <el-table-column
          prop="id"
          label="ID"
          width="80">
      </el-table-column>
      <el-table-column
          prop="username"
          label="用户名">
      </el-table-column>
      <el-table-column
          label="角色">
        <template slot-scope="scope">
          <el-tag v-for="role in scope.row.roles" :key="role.id" size="small" style="margin-right: 5px;">
            {{ role.role_name }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column
          label="状态"
          width="100">
        <template slot-scope="scope">
          <el-tag :type="scope.row.status === 1 ? 'success' : 'danger'">
            {{ scope.row.status === 1 ? '启用' : '禁用' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column
          prop="created_at"
          label="创建时间">
      </el-table-column>
      <el-table-column
          label="操作"
          width="280"
          fixed="right">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button size="mini" @click="handleAssignRoles(scope.row)">分配角色</el-button>
          <el-dropdown @command="handleCommand($event, scope.row)" style="margin-left: 8px;">
            <el-button size="mini">
              更多操作<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="resetPassword">
                <i class="el-icon-key"></i> 修改密码
              </el-dropdown-item>
              <el-dropdown-item command="toggleStatus" :disabled="scope.row.username === 'admin'">
                <i :class="scope.row.status === 1 ? 'el-icon-turn-off' : 'el-icon-open'"></i>
                {{ scope.row.status === 1 ? '禁用' : '启用' }}
              </el-dropdown-item>
              <el-dropdown-item command="delete" divided :disabled="scope.row.username === 'admin'">
                <span style="color: #F56C6C;"><i class="el-icon-delete"></i> 删除</span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="current_page"
        :page-size="per_page"
        :page-sizes="[20, 30, 50, 100]"
        :pager-count="11"
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
    </el-pagination>

    <!-- 添加/编辑用户对话框 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible">
      <el-form :model="form" :rules="formRules" ref="form" label-width="100px">
        <el-form-item label="用户名" prop="username">
          <el-input v-model="form.username" autocomplete="off" 
                    :disabled="editMode && form.username === 'admin'"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password" v-if="!editMode">
          <el-input v-model="form.password" type="password" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="re_password" v-if="!editMode">
          <el-input v-model="form.re_password" type="password" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="角色" prop="role_ids">
          <el-select v-model="form.role_ids" multiple placeholder="请选择角色" style="width: 100%">
            <el-option
                v-for="item in rolesList"
                :key="item.id"
                :label="item.role_name"
                :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSubmit">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 分配角色对话框 -->
    <el-dialog title="分配角色" :visible.sync="assignRolesVisible">
      <el-form :model="assignForm" label-width="100px">
        <el-form-item label="用户名">
          <el-input v-model="assignForm.username" disabled></el-input>
        </el-form-item>
        <el-form-item label="选择角色">
          <el-select v-model="assignForm.role_ids" multiple placeholder="请选择角色" style="width: 100%">
            <el-option
                v-for="item in rolesList"
                :key="item.id"
                :label="item.role_name"
                :value="item.id"
                :disabled="assignForm.username === 'admin' && item.role_code === 'admin'">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="assignRolesVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSubmitAssign">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 修改密码对话框 -->
    <el-dialog title="修改用户密码" :visible.sync="resetPasswordVisible" width="500px">
      <el-alert
        title="修改密码后，该用户的所有登录会话将被清除，需要重新登录"
        type="warning"
        :closable="false"
        style="margin-bottom: 20px;">
      </el-alert>
      <el-form :model="resetPasswordForm" :rules="resetPasswordRules" ref="resetPasswordForm" label-width="100px">
        <el-form-item label="用户名">
          <el-input v-model="resetPasswordForm.username" disabled></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="new_password">
          <el-input v-model="resetPasswordForm.new_password" type="password" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="re_new_password">
          <el-input v-model="resetPasswordForm.re_new_password" type="password" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="resetPasswordVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSubmitResetPassword">确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>

// 对Date的扩展，将 Date 转化为指定格式的String
// 月(M)、日(d)、小时(h)、分(m)、秒(s)、季度(q) 可以用 1-2 个占位符，
// 年(y)可以用 1-4 个占位符，毫秒(S)只能用 1 个占位符(是 1-3 位的数字)
// 例子：
// (new Date()).Format("yyyy-MM-dd hh:mm:ss.S") ==> 2006-07-02 08:09:04.423
// (new Date()).Format("yyyy-M-d h:m:s.S") ==> 2006-7-2 8:9:4.18

Date.prototype.Format = function (fmt) { // author: meizz
  var o = {
    "M+": this.getMonth() + 1, // 月份
    "d+": this.getDate(), // 日
    "h+": this.getHours(), // 小时
    "m+": this.getMinutes(), // 分
    "s+": this.getSeconds(), // 秒
    "q+": Math.floor((this.getMonth() + 3) / 3), // 季度
    "S": this.getMilliseconds() // 毫秒
  };
  if (/(y+)/.test(fmt))
    fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
  for (var k in o)
    if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
  return fmt;
}

export default {
  name: 'Users',
  data() {
    return {
      tableData: [],
      rolesList: [],
      current_page: 1,
      per_page: 20,
      total: 0,
      dialogFormVisible: false,
      assignRolesVisible: false,
      resetPasswordVisible: false,
      editMode: false,
      form: {
        username: '',
        password: '',
        re_password: '',
        role_ids: []
      },
      assignForm: {
        user_id: 0,
        username: '',
        role_ids: []
      },
      resetPasswordForm: {
        user_id: 0,
        username: '',
        new_password: '',
        re_new_password: ''
      },
      formRules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, message: '密码长度至少6位', trigger: 'blur' }
        ],
        re_password: [
          { required: true, message: '请再次输入密码', trigger: 'blur' },
          { 
            validator: (rule, value, callback) => {
              if (value !== this.form.password) {
                callback(new Error('两次输入密码不一致'));
              } else {
                callback();
              }
            }, 
            trigger: 'blur' 
          }
        ]
      },
      resetPasswordRules: {
        new_password: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 6, message: '密码长度至少6位', trigger: 'blur' }
        ],
        re_new_password: [
          { required: true, message: '请再次输入新密码', trigger: 'blur' },
          { 
            validator: (rule, value, callback) => {
              if (value !== this.resetPasswordForm.new_password) {
                callback(new Error('两次输入密码不一致'));
              } else {
                callback();
              }
            }, 
            trigger: 'blur' 
          }
        ]
      }
    };
  },
  computed: {
    dialogTitle() {
      return this.editMode ? '编辑用户' : '添加用户';
    }
  },
  mounted() {
    this.getUserList();
    this.getRolesList();
  },
  methods: {
    getUserList() {
      this.http.fetchGet(this.api.user_list, {
        page: this.current_page,
        limit: this.per_page
      }).then((res) => {
        if (res.data.code === 200) {
          this.tableData = res.data.data.data || [];
          this.total = res.data.data.total || 0;
        } else {
          this.$message.error(res.data.msg);
        }
      }).catch(err => {
        console.log(err);
        this.$message.error('获取用户列表失败');
      });
    },
    getRolesList() {
      this.http.fetchGet(this.api.role_all).then((res) => {
        if (res.data.code === 200) {
          this.rolesList = res.data.data || [];
        }
      }).catch(err => {
        console.log(err);
      });
    },
    handleAdd() {
      this.editMode = false;
      this.form = {
        username: '',
        password: '',
        re_password: '',
        role_ids: []
      };
      this.dialogFormVisible = true;
      if (this.$refs.form) {
        this.$refs.form.resetFields();
      }
    },
    handleEdit(row) {
      this.editMode = true;
      this.form = {
        id: row.id,
        username: row.username,
        role_ids: row.roles ? row.roles.map(r => r.id) : []
      };
      this.dialogFormVisible = true;
      if (this.$refs.form) {
        this.$nextTick(() => {
          this.$refs.form.clearValidate();
        });
      }
    },
    handleSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.editMode) {
            // 更新用户
            this.http.fetchPut(this.api.user_update + '/' + this.form.id, {
              username: this.form.username,
              role_ids: this.form.role_ids
            }).then((res) => {
              if (res.data.code === 200) {
                this.$message.success('更新成功');
                this.dialogFormVisible = false;
                this.getUserList();
              } else {
                this.$message.error(res.data.msg);
              }
            }).catch(err => {
              console.log(err);
              this.$message.error('更新失败');
            });
          } else {
            // 创建用户
            this.http.fetchPost(this.api.user_create, this.form).then((res) => {
              if (res.data.code === 200) {
                this.$message.success('添加成功');
                this.dialogFormVisible = false;
                this.getUserList();
              } else {
                this.$message.error(res.data.msg);
              }
            }).catch(err => {
              console.log(err);
              this.$message.error('添加失败');
            });
          }
        }
      });
    },
    handleAssignRoles(row) {
      this.assignForm = {
        user_id: row.id,
        username: row.username,
        role_ids: row.roles ? row.roles.map(r => r.id) : []
      };
      this.assignRolesVisible = true;
    },
    handleSubmitAssign() {
      // 检查admin用户是否保留admin角色
      if (this.assignForm.username === 'admin') {
        const hasAdminRole = this.assignForm.role_ids.some(roleId => {
          const role = this.rolesList.find(r => r.id === roleId);
          return role && role.role_code === 'admin';
        });
        
        if (!hasAdminRole) {
          this.$message.error('不允许移除admin用户的系统管理员角色');
          return;
        }
      }
      
      this.http.fetchPost(this.api.user_assign_roles + '/' + this.assignForm.user_id + '/roles', {
        role_ids: this.assignForm.role_ids,
        mode: 'replace'
      }).then((res) => {
        if (res.data.code === 200) {
          this.$message.success('分配角色成功');
          this.assignRolesVisible = false;
          this.getUserList();
        } else {
          this.$message.error(res.data.msg);
        }
      }).catch(err => {
        console.log(err);
        this.$message.error('分配角色失败');
      });
    },
    handleCommand(command, row) {
      switch(command) {
        case 'resetPassword':
          this.handleResetPassword(row);
          break;
        case 'toggleStatus':
          this.handleToggleStatus(row);
          break;
        case 'delete':
          this.handleDelete(row);
          break;
      }
    },
    handleResetPassword(row) {
      this.resetPasswordForm = {
        user_id: row.id,
        username: row.username,
        new_password: '',
        re_new_password: ''
      };
      this.resetPasswordVisible = true;
      if (this.$refs.resetPasswordForm) {
        this.$nextTick(() => {
          this.$refs.resetPasswordForm.clearValidate();
        });
      }
    },
    handleSubmitResetPassword() {
      this.$refs.resetPasswordForm.validate((valid) => {
        if (valid) {
          this.$confirm(`确定要修改用户 ${this.resetPasswordForm.username} 的密码吗？修改后该用户的所有登录会话将失效！`, '警告', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.http.fetchPut(this.api.user_update + '/' + this.resetPasswordForm.user_id + '/password', {
              new_password: this.resetPasswordForm.new_password,
              re_new_password: this.resetPasswordForm.re_new_password
            }).then((res) => {
              if (res.data.code === 200) {
                this.$message.success(res.data.msg);
                this.resetPasswordVisible = false;
                this.getUserList();
              } else {
                this.$message.error(res.data.msg);
              }
            }).catch(err => {
              console.log(err);
              this.$message.error('修改密码失败');
            });
          }).catch(() => {});
        }
      });
    },
    handleToggleStatus(row) {
      const newStatus = row.status === 1 ? 0 : 1;
      const action = newStatus === 1 ? '启用' : '禁用';
      
      this.$confirm(`确定要${action}用户 ${row.username} 吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.http.fetchPut(this.api.user_status + '/' + row.id + '/status', {
          status: newStatus
        }).then((res) => {
          if (res.data.code === 200) {
            this.$message.success(`${action}成功`);
            this.getUserList();
          } else {
            this.$message.error(res.data.msg);
          }
        }).catch(err => {
          console.log(err);
          this.$message.error(`${action}失败`);
        });
      }).catch(() => {});
    },
    handleDelete(row) {
      this.$confirm(`确定要删除用户 ${row.username} 吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.http.fetchDel(this.api.user_delete + '/' + row.id).then((res) => {
          if (res.data.code === 200) {
            this.$message.success('删除成功');
            this.getUserList();
          } else {
            this.$message.error(res.data.msg);
          }
        }).catch(err => {
          console.log(err);
          this.$message.error('删除失败');
        });
      }).catch(() => {});
    },
    handleSizeChange(val) {
      this.per_page = val;
      this.getUserList();
    },
    handleCurrentChange(val) {
      this.current_page = val;
      this.getUserList();
    }
  }
}
</script>

<style scoped>
</style>
